import z from 'zod';

export const TicketMessageSchema = z.object({
    message: z
        .string({
            message: 'پیام پشتیبانی الزامی میباشد'
        })
        .trim()
        .min(1, { message: 'پیام پشتیبانی نمیتواند خالی باشد' })
});

export const TicketComposeSchema = z.object({
    title: z
        .string()
        .min(3, { message: 'عنوان درخواست باید حداقل 3 کاراکتر باشد' })
        .max(150, { message: 'عنوان درخواست نباید بیشتر از ۱۵۰ کاراکتر باشد' }),

    description: z
        .string()
        .min(10, { message: 'حداقل توضیحات باید ۱۰ کاراکتر باشد' })
        .max(3000, { message: 'حداکثر توضیحات ۳۰۰۰ کاراکتر است' }),

    category: z.preprocess(
        (val) => (val == null ? '' : String(val).trim()),
        z.string().min(1, { message: 'لطفاً یک دسته‌بندی انتخاب کنید' })
    )
});

export type TicketMessageFormValues = z.infer<typeof TicketMessageSchema>;
export type TicketComposeFormValues = z.infer<typeof TicketComposeSchema>;

